import * as React from 'react';

import { inputUtils } from '../input-utils';
import { SearchItemsWithDropdownList } from '../search-items-with-dropdown-list';

/**
 * @deprecated better use InputSelectNew
 */
export const InputSelect = (props) => {
  const {
    elements,
    activeElementIndex,
    closeAfterClick = false,
    maxItemsAmount = 5,
    onClick,
    onDropdownOpenChanged,
  } = props;

  const onClickCallback = React.useCallback((id) => {
    const elementIndex = elements.indexOf(id);
    onClick(elementIndex);
  }, [onClick, elements]);

  const {
    isDropdownOpen,
    onOpenDropdown,
    innerSideRef,
    onChangeValue,
    onClickArrowContainer,
    onClickDropDownTextItem,
    filteredElements,
  } = inputUtils(closeAfterClick, onClickCallback, elements);

  React.useEffect(() => {
    if (onDropdownOpenChanged) {
      onDropdownOpenChanged(isDropdownOpen);
    }
  }, [onDropdownOpenChanged, isDropdownOpen]);

  const activeElement = elements[activeElementIndex];

  return (
    <SearchItemsWithDropdownList
      isDropdownOpen={isDropdownOpen}
      onOpenDropdown={onOpenDropdown}
      innerSideRef={innerSideRef}
      onChangeValue={onChangeValue}
      activeElement={activeElement}
      onClickArrowContainer={onClickArrowContainer}
      elements={elements}
      filteredElements={filteredElements}
      maxItemsAmount={maxItemsAmount}
      onClickDropDownTextItem={onClickDropDownTextItem}
    />
  );
};
